export default (value) => {
	return Math.floor(value)
}



// WEBPACK FOOTER //
// ./src/filters/global/floor.js